import { useContext } from 'react';

import { DataContext } from 'providers/data';

import { Typography, Box } from '@mui/material';

import NavTitle from 'components/views/NavTitle';

import { Card, BoxCustom } from './styles';

import { ReactComponent as IcDueDate } from 'assets/icons/ic-update-profile.svg';
import { ReactComponent as IcUpdatePlaque } from 'assets/icons/ic-update-plaque.svg';
import { ReactComponent as IcFormOfPayment } from 'assets/icons/ic-form-of-payment.svg';

import UpdateProfile from 'assets/images/update-profile.png';
import FormOfPayment from 'assets/images/form-of-payment.png';
import UpdatePlaque from 'assets/images/update-plaque.png';

const News = () => {
    const { blockClick, customerCars } = useContext(DataContext);

    const handleValidateLevel = () => {
        if (customerCars?.find(({ CD_PESSOA, CD_PESSOA_BENEFICIARIO }) => CD_PESSOA === CD_PESSOA_BENEFICIARIO)) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <Box sx={{
            paddingTop: {
                xs: '.81rem',
                md: '2.125rem'
            }
        }}>
            <NavTitle title='Atualização de Dados' />

            <Box sx={{
                width: '100%',
                display: 'grid',
                gap: { xs: '.5rem', md: '1rem' },
                gridTemplateColumns: '1fr 1fr 1fr',
                marginTop: { xs: '.6rem', md: '.75rem' },
                height: { xs: '5.9375rem', md: '8.75rem' }
            }}>
                <Card to={blockClick || !handleValidateLevel() ? '' : '/meus-dados'} state={{ showFocus: true }} className={blockClick || !handleValidateLevel() ? 'disabled' : ''}>
                    <Box sx={{
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        borderRadius: '.75rem .75rem 0 0',
                        backgroundImage: `url(${UpdateProfile})`
                    }} />
                    <BoxCustom sx={{
                        'svg': {
                            width: 'auto',
                            height: '2.5rem'
                        }
                    }}>
                        <IcDueDate />
                        <Typography sx={{ maxWidth: '8.6rem' }}>
                            Mantenha suas informações em dia
                        </Typography>
                    </BoxCustom>
                </Card>
                <Card to={blockClick || !handleValidateLevel() ? '' : '/faturas'} className={blockClick || !handleValidateLevel() ? 'disabled' : ''}>
                    <Box sx={{
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        borderRadius: '.75rem .75rem 0 0',
                        backgroundImage: `url(${FormOfPayment})`
                    }} />
                    <BoxCustom>
                        <IcFormOfPayment />
                        <Typography sx={{ maxWidth: '6.7rem' }}>
                            Troque a forma de pagamento
                        </Typography>
                    </BoxCustom>
                </Card>
                <Card to={blockClick ? '' : '/meus-veiculos'} className={blockClick ? 'disabled' : ''}>
                    <Box sx={{
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        borderRadius: '.75rem .75rem 0 0',
                        backgroundImage: `url(${UpdatePlaque})`
                    }} />
                    <BoxCustom>
                        <IcUpdatePlaque />
                        <Typography sx={{ maxWidth: '6.9rem' }}>
                            Atualize a placa<br /> do seu veículo
                        </Typography>
                    </BoxCustom>
                </Card>
            </Box>
        </Box >
    );
}

export default News;